module.exports = __webpack_public_path__ + "static/MongoDB-9b831411a7aade38b100e88928d8f485.svg";